<!-- Right Form Card -->
<div class="quote-card">
  <h2 class="card-title">{{ "LANDING.TITLE" | translate }}</h2>
  <p class="card-subtitle">
    {{ "LANDING.SUBTITLE" | translate }}
  </p>

  <p class="card-highlight">
    {{ "LANDING.GET_QUOTE_UNDER_2_MINUTES" | translate }}
  </p>

  <form class="quote-form">
    <div class="form-group">
      <label for="crNumber">{{ "LANDING.FORM.CR_NUMBER" | translate }}</label>
      <input
        type="text"
        id="crNumber"
        [(ngModel)]="crNumber"
        name="crNumber"
        #crNumberInput="ngModel"
        required
        pattern="^[0-9]{10}$"
        class="form-control"
        [placeholder]="'LANDING.FORM.CR_PLACEHOLDER' | translate"
      />
      <div
        *ngIf="
          crNumberInput.invalid &&
          (crNumberInput.dirty || crNumberInput.touched)
        "
        class="error-message"
      >
        <span *ngIf="crNumberInput.errors?.['required']"
          >CR Number is required.</span
        >
        <span *ngIf="crNumberInput.errors?.['pattern']"
          >CR Number must be exactly 10 digits.</span
        >
      </div>
    </div>

    <div class="form-group">
      <label for="entity700Number">{{ "LANDING.FORM.ENTITY_700_NUMBER" | translate }}</label>
      <input
        type="text"
        id="entity700Number"
        [(ngModel)]="entity700Number"
        name="entity700Number"
        class="form-control"
        [placeholder]="'LANDING.FORM.ENTITY_700_PLACEHOLDER' | translate"
      />
    </div>

    <div class="form-group">
      <label for="email">{{ "LANDING.FORM.EMAIL" | translate }}</label>
      <input
        type="email"
        id="email"
        [(ngModel)]="email"
        name="email"
        #emailInput="ngModel"
        required
        email
        class="form-control"
        [placeholder]="'LANDING.FORM.EMAIL_PLACEHOLDER' | translate"
      />
      <div
        *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)"
        class="error-message"
      >
        <span *ngIf="emailInput.errors?.['required']">Email is required.</span>
        <span *ngIf="emailInput.errors?.['email']"
          >Please enter a valid email.</span
        >
      </div>
    </div>

    <div class="form-group">
      <label for="phoneNumber">{{ "LANDING.FORM.PHONE" | translate }}</label>
      <input
        type="tel"
        id="phoneNumber"
        [(ngModel)]="phoneNumber"
        name="phoneNumber"
        #phoneInput="ngModel"
        required
        class="form-control"
        [placeholder]="'LANDING.FORM.PHONE_PLACEHOLDER' | translate"
      />
    </div>

    <button type="button" class="submit-btn" (click)="onContinue()">
      {{ "LANDING.FORM.GET_QUOTE_NOW" | translate }}
      <span class="arrow">→</span>
    </button>

    <p class="form-footer">
      {{ "LANDING.CONSENT_TEXT" | translate }}
    </p>
  </form>
</div>
